import React, { FC, useEffect, useState } from 'react';
import { ProductCategorySectionHead } from './ProductCategorySectionHead';
import { AccordionSection } from '../AccordionSection';
import { ProductItem } from './ProductItem';
import styled from 'styled-components';
import { Colors } from '../../../styles/colors';
import {
  parseProductColorSet,
  parseProductColorSetIcon,
  parseProductItemType,
  ProductItemType,
} from './icons/ProductIconWrapper';
import { Product, ProductCategory } from '../../../interfaces/Product';
import { useAttachmentDataUrl } from '../../../utils/Attachments';
import { calculateAnimationDelayItemsAppear } from '../AnimatedContainer';

const Separator = styled.div`
	background-color: ${Colors.gray};
	height: 1px;
`;

const AccordionSectionWrapper = styled.div`
  padding: 2rem 0 0;
  
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: .75rem;
`;

interface Props {
  item: ProductCategory;
  unfilteredItem?: ProductCategory;
  index: number;
  active?: boolean;
  setActive?: (active: boolean) => void;
  onProductItemClick?: (productItem: Product) => void;
  additionalList?: boolean;
  showTechnicalName?: boolean;
}
export const ProductCategorySection: FC<Props> = ({ item, index, active = true, setActive, ...props }) => {
  const { name, description, imageId } = item;
  const { additionalList = false, showTechnicalName = false } = props;
  const imageUrl = useAttachmentDataUrl(imageId);

  return (
    <>
    <ProductCategorySectionHead
      sectionId={item.id}
      title={name}
      imageUrl={imageUrl}
      // teaserText={description}
      // greenProduct={(item.products || []).filter((item) => !item.eco).length < 1 && (item.products || []).length > 0}
      filteredCount={(props.unfilteredItem?.products?.length > (item.products || []).length) ? (item.products || []).length : undefined}
      count={props.unfilteredItem?.products?.length || (item.products || []).length}
      active={active}
      setActive={setActive}
    />
    <Separator />
    <AccordionSection collapsed={!active}>
      <AccordionSectionWrapper>
        {
          (item.products || []).map((item, index, array) => (
            <ProductItem
              animationActive={active}
              animationDelay={calculateAnimationDelayItemsAppear(active, index, array.length)}
              additionalListItem={additionalList}
              onClick={() => {
                if (props.onProductItemClick) {
                  props.onProductItemClick(item);
                }
              }}
              color={parseProductColorSetIcon(item.metaProduct?.colorSet)}
              type={parseProductItemType(item.type)}
            >
              { showTechnicalName ? item.name : item.displayName || item.name }
            </ProductItem>
          ))
        }
      </AccordionSectionWrapper>
    </AccordionSection>
    </>
  );
}
